
































import Vue, { PropOptions } from 'vue';
import { AppRouteLink } from '../../data/routes';
import UIStore from '../../store/modules/ui';
import permissionsStore from '../../store/modules/permissions';
import STopNav from '../STopNav/STopNav.vue';
import SPageLoading from '../SPageLoading/SPageLoading.vue';

export default Vue.extend({
  name: 'SApp',
  components: {
    STopNav,
    SPageLoading,
  },
  props: {
    sidebarRoutes: { type: Array } as PropOptions<AppRouteLink[]>,
    loading: { type: Boolean },
    /**
     * The name of the app using the baseplate
     */
    appName: {
      type: String,
      required: false,
      default: 'Stratum Five',
    },
    /**
     * Whether or not to use the altenate mode (legacy) that has a full sidebar and no top
     * left logo
     */
    alternate: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Customise the text displayed while the app is loading
     */
    loadingText: {
      type: String,
      required: false,
      default: 'Initialising…',
    },
    /**
     * Show progress in a loading bar
     */
    loadingProgress: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    showNav(): boolean {
      return this.$store.state.sUI.topNav;
    },
  },
  created(): void {
    const store = this.$store;
    if (store && store.state) {
      if (!store.state.sUI) {
        store.registerModule('sUI', UIStore);
      }
      if (!store.state.sPermissions) {
        store.registerModule('sPermissions', permissionsStore);
      }
    }
  },
});
